var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { padding: "0 20px", background: "#fff" } },
    [
      _c(
        "a-tabs",
        {
          attrs: { activeKey: _vm.activeKey, destroyInactiveTabPane: "" },
          on: { change: _vm.changeTab },
        },
        [
          _vm._l(_vm.tabList, function (item, index) {
            return _c(
              "a-tab-pane",
              { key: item.key, attrs: { tab: item.tab } },
              [
                item.key === "2"
                  ? _c("CollapseResource", {
                      attrs: {
                        title: "制度建设",
                        actionUrl: _vm.currTabObj.url,
                        sortDictCode: "research_sort",
                        isShowSort: item.key === "5",
                        actionType: item.key,
                      },
                    })
                  : _c("SchemeCard", {
                      key: item.key,
                      ref: "schemeCardRef",
                      refInFor: true,
                      attrs: {
                        actionUrl: _vm.currTabObj.url,
                        cardType: item.cardType,
                        fileUploadKey: _vm.currTabObj.fileUploadKey,
                        keysFormArr: _vm.currTabObj.keysFormArr,
                        cateDictCode: _vm.currTabObj.dictCode,
                        acceptSuffix: _vm.currTabObj.acceptSuffix,
                      },
                      on: { cardClick: _vm.schemeCardClick },
                    }),
              ],
              1
            )
          }),
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeKey !== "2",
                  expression: "activeKey !== '2'",
                },
              ],
              attrs: { slot: "tabBarExtraContent", type: "primary" },
              on: { click: _vm.createLeague },
              slot: "tabBarExtraContent",
            },
            [_vm._v("\n      创建\n    ")]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }